<template>
  <div>
    <div class="projet-part">
      <h2 id="site">{{ $t("projet.inscription.site-inscription.titre") }}</h2>
      <RadioWithInputAndValidation
        rules="required"
        :data="natures"
        :option-labels="natureLabels"
        :model-value="projetAnnuel.natureAireEducative"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        :vertical-display="true"
        :disabled="readonly"
        :label="$t('projet.inscription.site-inscription.nature-question')"
        :input-notice="
          projetAnnuel.etat == 'EN_COURS_DE_CREATION'
            ? $t('projet.inscription.site-inscription.nature-question-notice')
            : ''
        "
        vid="site_1"
        @update:model-value="updateNatureaireeducative"
        @manual-change="modified"
      />
      <InputWithValidation
        :label="$t('projet.inscription.site-inscription.repere.question')"
        rules="required"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        :model-value="projetAnnuel.contexteSitesPotentiels"
        type="textarea"
        :disabled="readonly || projetAnnuel.statut !== 'BROUILLON'"
        vid="site_2"
        @update:model-value="updateContextesitespotentiels"
        @manual-change="modified"
      />
      <div>
        {{ $t("projet.inscription.site-inscription.repere.sites-potentiels-tooltip") }}
      </div>
      <div>
        {{ $t("projet.inscription.site-inscription.repere.sites-potentiels-tooltip2") }}
      </div>
      <div>
        {{ $t("projet.inscription.site-inscription.repere.sites-potentiels-tooltip3") }}
      </div>
      <div>{{ $t("projet.inscription.site-inscription.repere.sites-potentiels-link") }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { ProjetInscriptionDTO } from "@/model/bean/GeneratedDTOs"
import { defineComponent } from "vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import RadioWithInputAndValidation from "@/views/inputs/RadioWithInputAndValidation.vue"
import { EnumHelper } from "@/model/bean/EnumHelper"

export default defineComponent({
  name: "ProjetInscriptionSite",
  components: { InputWithValidation, RadioWithInputAndValidation },
  props: {
    projetAnnuel: {
      type: Object as () => ProjetInscriptionDTO,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    validationActivated: {
      type: Boolean,
      default: true,
    },
    showValidationErrors: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["dirtify-project", "projet-annuel-updated", "trigger-validation"],
  data() {
    return {
      natures: EnumHelper.allNatures,
    }
  },
  computed: {
    natureLabels(): string[] {
      return this.natures.map((nature) => {
        return this.$t(`projet.inscription.site-inscription.nature-labels.${nature}`).toString()
      })
    },
  },
  methods: {
    updateNatureaireeducative(newValue: any): void {
      this.modified()
      const updatedProjetannuel = {
        ...this.projetAnnuel,
        natureAireEducative: newValue,
      }
      this.$emit("projet-annuel-updated", updatedProjetannuel)
    },
    updateContextesitespotentiels(newValue: any): void {
      this.modified()
      const updatedProjetannuel = {
        ...this.projetAnnuel,
        contexteSitesPotentiels: newValue,
      }
      this.$emit("projet-annuel-updated", updatedProjetannuel)
    },

    modified(): void {
      this.$nextTick(() => {
        this.$emit("dirtify-project")
        this.$emit("trigger-validation")
      })
    },
  },
})
</script>
